import React from 'react'

function SobreMi() {
    return (
        <div className="todo_sobre_mi">
            <div id="sobre_mi">
                <div className="titulo_sobre_mi">
                    <h3>SOBRE MÍ</h3>
                </div>
                <div className="nombre_sobre_mi">
                    Raúl Domínguez Robles
                </div>
                <div className="acerca_de_mi">
                    <div className="descripcion">
                        <div className="parrafo">
                            Soy un joven desarrollador de software especializado en aplicaciones web Full Stack, con experiencia en diversas tecnologías.
                        </div>
                        <div className="parrafo">
                            He obtenido el título de Grado Superior de Desarrollo de Aplicaciones Web y tengo un nivel avanzado de inglés (B2/C1).
                        </div>
                        <div className="parrafo">
                            Actualmente vivo en Fuenlabrada, Madrid y cuento con carnet de conducir tipo B.
                        </div>
                        <div className="parrafo">
                            Además, tengo un año de experiencia trabajando como freelancer y en proyectos personales, lo que me ha permitido adquirir amplios conocimientos en varias tecnologías.
                        </div>
                    </div>
                    <div className="titulacion">
                        <div className="titu">
                            <div className="titulo_titulacion">
                                Grado Superior de Desarrollo de Aplicaciones Web
                            </div>
                            <div className="graduado">
                                Graduado en IES Melchor Gaspar de Jovellanos
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SobreMi
